import { triggerHeaderCategoryChanged } from '../../../shared/utils/events';
import { init as fastInit } from '../../fast';
import { FastFilters } from '../../fast/fast_filters';
import { getConfig } from '@cian/config/browser';
import { ISerializableAppState } from '../../../shared/common/state';
import { runOnDocumentLoaded } from '../../utils/runOnDocumentLoaded';

export function runApp() {
  const state = getConfig().getStrict<ISerializableAppState>('initialState');

  let fastInitDestructor: (() => FastFilters) | void;
  let fullBundleLoaded = false;

  setTimeout(() => {
    runOnDocumentLoaded(() => {
      if (!fullBundleLoaded) {
        fastInitDestructor = fastInit(state);
      }

      triggerHeaderCategoryChanged(state.filters.jsonQuery);
    });
  }, 50);

  const loadFull = async () => {
    if (window.performance && window.performance.mark) {
      window.performance.mark('frontend-serp.full-bundle-download-compile');
    }

    const { init: fullInit } = await import(/* webpackMode: "lazy" */ '../../full');

    runOnDocumentLoaded(() => {
      let fastFilters: FastFilters | undefined;

      if (fastInitDestructor) {
        fastFilters = fastInitDestructor();
        fastInitDestructor = undefined;
      }

      fullBundleLoaded = true;
      fullInit(state, fastFilters);
    });
  };

  if (location.hash.indexOf('fast-bundle=window') >= 0) {
    // tslint:disable-next-line:no-any
    (window as any).loadFull = loadFull;
  } else if (location.hash.indexOf('fast-bundle=timeout') >= 0) {
    setTimeout(loadFull, 5000);
  } else {
    loadFull();
  }
}
